'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Error = {};

exports.__exports = _Error;
